/*=========================================================================================
  File Name: moduleSpaceActions.js
  Description: Space Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"
// import store from "../store.js"
// import router from '@/router'

export default {
    // Set mails flag unread to true
    createProjectBlogNode({ commit }, payload) {
      // commit("SET_ACTIVE_PROJECT_TITLE", payload.title)
      return new Promise((resolve, reject) => {
        axios.post("/api/project/blog/node/create", payload).then((response) =>{
          if(response.data.result == 'success'){
            commit("CREATE_BLOG_DIR", response.data.data)
            resolve(response)
          }
          reject(resolve)
        }).catch((error) => { reject(error) })
      })
    },
    updateProjectBlogNode({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post("/api/project/blog/node/update", payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("UPDATE_BLOG_DIR", response.data.data)
              resolve(response)
            }
            reject(response)
          }).catch((error) => { reject(error) })
      })
    },
    updateProjectBlogNodeName({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post("/api/project/blog/node/name/update", payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("UPDATE_BLOG_DIR_NAME", payload)
              resolve(response)
            }
            reject(response)
          }).catch((error) => { reject(error) })
      })
    },
    updateProjectBlog({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post("/api/project/blog/update", payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("SET_ACTIVE_BLOG", response.data.data)
              resolve(response)
            }
            reject(response)
          }).catch((error) => { reject(error) })
      })
    },
    deleteProjectBlogNode({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.delete("/api/project/blog/node/delete/"+ payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("DELETE_BLOG_DIR", payload)
              resolve(response)
            }
            reject(response)
          }).catch((error) => { reject(error) })
      })
    },
    deleteProjectBlog(context, payload){
      return new Promise((resolve, reject) => {
        axios.delete("/api/project/blog/delete/"+ payload)
          .then((response) => {
            if(response.data.result == 'success'){
              resolve(response)
            }
            reject(response)
          }).catch((error) => { reject(error) })
      })
    },
    getProjectBlogNode({ commit }, payload) {
      // var projectInfo = {"project_id": payload.project_Id}
      return new Promise((resolve, reject) => {
        axios.get("/api/project/blog/node/"+payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("SET_BLOG_DIR", response.data.data_list)
              resolve(response)
            }
            reject(response)
          }).catch((error) => { reject(error) })
        })
    },
    getProjectBlog({ commit }, payload) {
      // var projectInfo = {"project_id": payload.project_Id}
      return new Promise((resolve, reject) => {
        axios.get("/api/project/blog/"+payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("SET_ACTIVE_BLOG", response.data.data)
              resolve(response)
            }
            reject(response)
          }).catch((error) => { reject(error) })
        })
    },
    getUserBlog(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get("/api/project/blog/user/"+payload)
          .then((response) => {
            if(response.data.result == 'success'){
              // commit("SET_USER_BLOG", response.data.data_list)
              resolve(response.data.data)
            }
            reject(response)
          }).catch((error) => { reject(error) })
        })
    }
}
